module.exports = __webpack_public_path__ + "01_veryshort_gold.823d4e2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_veryshort_gold.png
// module id = rmGX
// module chunks = 0